module.exports = __webpack_public_path__ + "static/media/mmt symbols-1.db2197f2.jpg";